module.exports = __webpack_public_path__ + "img/no-image-placeholder.588d9346.jpg";